// PostHog Analytics
!function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);

if (process.env.POSTHOG_API_KEY) {
  posthog.init(process.env.POSTHOG_API_KEY, {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'always'
  });
}

// Main JavaScript for Diego Gonzalez's website

// Global references that will be set via script tags
// These variables will be populated by script tags in the HTML
// const THREE = window.THREE;
// const SceneSetup = window.SceneSetup;
// const ViewerControls = window.ViewerControls;

class Viewer {
    constructor(container) {
        console.log("Initializing 3D Viewer");
        
        // Initialize scene setup
        this.sceneSetup = new SceneSetup({
            container: container,
            backgroundColor: 0x222222,
            antialias: true,
            debug: true
        });
        
        // Initialize controls
        this.controls = new ViewerControls({
            camera: this.sceneSetup.camera,
            domElement: this.sceneSetup.renderer.domElement,
            enableDamping: true,
            enableZoom: true,
            enablePan: true,
            dampingFactor: 0.05,
            rotateSpeed: 0.7,
            zoomSpeed: 1.0
        });
        
        // Add a sample object
        this._addSampleObject();
        
        // Start animation loop
        this.animate();
        
        console.log("Viewer initialization complete");
    }
    
    _addSampleObject() {
        // Create a simple cube
        const geometry = new THREE.BoxGeometry(1, 1, 1);
        const material = new THREE.MeshStandardMaterial({ 
            color: 0x3498db,
            roughness: 0.5,
            metalness: 0.2
        });
        const cube = new THREE.Mesh(geometry, material);
        
        // Add to scene with tracking
        this.sceneSetup.addObject('sampleCube', cube);
        
        // Auto-rotate the cube
        this.autoRotate = true;
    }
    
    animate = () => {
        requestAnimationFrame(this.animate);
        
        // Update controls
        this.controls.update();
        
        // Animate sample object if enabled
        if (this.autoRotate) {
            const cube = this.sceneSetup.getObject('sampleCube');
            if (cube) {
                cube.rotation.x += 0.01;
                cube.rotation.y += 0.01;
            }
        }
        
        // Render the scene
        this.sceneSetup.render();
    }
    
    resize() {
        // This will trigger the onWindowResize in SceneSetup
        this.sceneSetup.onWindowResize();
    }
    
    dispose() {
        console.log("Disposing Viewer");
        
        // Cancel animation loop
        if (this.animationFrameId) {
            cancelAnimationFrame(this.animationFrameId);
        }
        
        // Dispose controls
        if (this.controls) {
            this.controls.dispose();
        }
        
        // Dispose scene setup
        if (this.sceneSetup) {
            this.sceneSetup.dispose();
        }
    }
}

// Initialize the viewer when the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('viewer-container');
    if (container) {
        window.viewer = new Viewer(container);
        
        // Handle window resize
        window.addEventListener('resize', () => {
            if (window.viewer) {
                window.viewer.resize();
            }
        });
    } else {
        console.error('Viewer container not found');
    }

    // Smooth scrolling for navigation links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            
            const targetId = this.getAttribute('href');
            if (targetId === '#') return;
            
            const targetElement = document.querySelector(targetId);
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });

    // Resume viewer functionality
    const viewResumeButton = document.querySelector('.view-resume');
    const resumePreview = document.querySelector('.resume-preview');
    
    if (viewResumeButton && resumePreview) {
        viewResumeButton.addEventListener('click', (e) => {
            e.preventDefault();
            
            // This would be replaced with an actual PDF viewer like PDF.js
            // For now, we'll just create a simple iframe embed
            resumePreview.innerHTML = `
                <div class="resume-viewer">
                    <div class="resume-viewer-header">
                        <h3>Resume Preview</h3>
                        <button class="close-preview">&times;</button>
                    </div>
                    <div class="resume-viewer-content">
                        <iframe src="/files/diego-gonzalez-resume.pdf" width="100%" height="500px"></iframe>
                    </div>
                </div>
            `;
            
            // Add functionality to close button
            const closeButton = resumePreview.querySelector('.close-preview');
            if (closeButton) {
                closeButton.addEventListener('click', () => {
                    resumePreview.innerHTML = '';
                });
            }
        });
    }

});

// Make viewer available globally instead of using export
if (typeof window !== 'undefined') {
    window.Viewer = Viewer;
} 